<template>
  <page-form />
</template>

<script>
import PageForm from '@/components/forms/PageForm'
export default {
  components: {
    PageForm
  }
}
</script>
